import type { DashboardInventory, Site } from "@shared/types";

export const ALL_SITES_KEY = "all";

export function filterBySiteId<T extends { site_id: string }>(
  items: T[],
  activeSiteId: string
) {
  if (activeSiteId === ALL_SITES_KEY) {
    return items;
  }

  return items.filter((item) => item.site_id === activeSiteId);
}

export function filterInventoryBySiteId(
  inventory: DashboardInventory,
  activeSiteId: string
): DashboardInventory {
  if (activeSiteId === ALL_SITES_KEY) {
    return inventory;
  }

  return {
    organizations: inventory.organizations
      .map((organization) => ({
        ...organization,
        projects: organization.projects.filter(
          (project) => project.id === activeSiteId
        ),
      }))
      .filter((organization) => organization.projects.length > 0),
  };
}

export function matchesSiteQuery(site: Site, query: string) {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return true;
  }

  return `${site.name} ${site.primary_url} ${site.slug}`
    .toLowerCase()
    .includes(normalizedQuery);
}
